import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs';
import { IdentificacaoAtendimento } from 'src/app/models/Servico.model';

@Component({
  selector: 'app-pesquisa-servico-concluida',
  templateUrl: './pesquisa-servico-concluida.component.html',
  styleUrls: ['./pesquisa-servico-concluida.component.css'],
})
export class PesquisaServicoConcluidaComponent {
  id?: IdentificacaoAtendimento;

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.activatedRoute.paramMap
      .pipe(filter((data) => data.has('id') && data.has('ano')))
      .subscribe((params) => {
        const id = Number(params.get('id'));
        const ano = Number(params.get('ano'));

        this.id = new IdentificacaoAtendimento(id, ano, '');
      });
  }
}
